import React, { useState, useEffect, useCallback } from 'react';
import AdminNavbar from '../Navbars/AdminNavbar';
import AdminSidebar from '../Sidebar/AdminSidebar';
import { SuperAdminApis } from '../../apis/superAdminApi';
import { AxiosResponse } from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Oval } from 'react-loader-spinner';
//@ts-ignore
import Modal from 'react-awesome-modal';
import { SvgElement, icontypesEnum } from '../assets/svgElement';

function LegacyMigration() {
    const [tabNo, setTabNo] = useState('1'); // 1=fleets, 2=riders
    const [fleets, setFleets] = useState<any>([]);
    const [riders, setRiders] = useState<any>([]);
    const [stats, setStats] = useState<any>(null);
    const [loader, setLoader] = useState(false);
    const [actionLoader, setActionLoader] = useState(false);
    const [search, setSearch] = useState('');
    const [fleetFilter, setFleetFilter] = useState('');
    const [fleetList, setFleetList] = useState<any>([]); // For fleet name dropdown

    // Migrate fleet modal
    const [migrateFleetModal, setMigrateFleetModal] = useState(false);
    const [migrateFleetUser, setMigrateFleetUser] = useState<any>(null);
    const [autoMigrateRiders, setAutoMigrateRiders] = useState(false);
    const [fleetRiderRates, setFleetRiderRates] = useState({ metro_rate: '', other_rate: '' });

    // Migrate rider modal
    const [migrateRiderModal, setMigrateRiderModal] = useState(false);
    const [migrateRiderUser, setMigrateRiderUser] = useState<any>(null);
    const [riderData, setRiderData] = useState({ metro_rate: '', other_rate: '', rider_town: '', branch: '' });

    // Bulk
    const [selectedIds, setSelectedIds] = useState<number[]>([]);
    const [bulkModal, setBulkModal] = useState(false);
    const [bulkData, setBulkData] = useState({ metro_rate: '', other_rate: '', rider_town: '', branch: '' });

    // ── Load data ──────────────────────────────────────────────
    const loadStats = () => {
        SuperAdminApis.getLegacyMigrationStats().then((res: AxiosResponse<any>) => {
            if (res?.data?.status) setStats(res.data.data);
        });
    };

    const loadFleets = useCallback((page?: string) => {
        setLoader(true);
        SuperAdminApis.getUnmigratedFleets({ search, page: page || '1', per_page: '20' }).then((res: AxiosResponse<any>) => {
            setLoader(false);
            if (res?.data?.status) setFleets(res.data.data);
        }).catch(() => setLoader(false));
    }, [search]);

    const loadRiders = useCallback((page?: string) => {
        setLoader(true);
        SuperAdminApis.getUnmigratedRiders({ search, fleet_id: fleetFilter, page: page || '1', per_page: '20' }).then((res: AxiosResponse<any>) => {
            setLoader(false);
            if (res?.data?.status) setRiders(res.data.data);
        }).catch(() => setLoader(false));
    }, [search, fleetFilter]);

    // Load fleet list for the dropdown filter
    const loadFleetList = () => {
        SuperAdminApis.getAllFleetWithoutPagination("", { search: '' })
            .then((response: AxiosResponse<any>) => {
                const data = response?.data?.data;
                setFleetList(data?.data || data || []);
            })
            .catch(() => setFleetList([]));
    };

    useEffect(() => {
        loadStats();
        loadFleets();
        loadFleetList();
    }, []);

    useEffect(() => {
        setSelectedIds([]);
        setSearch('');
        if (tabNo === '1') loadFleets(); else loadRiders();
    }, [tabNo]);

    // ── Search handler ─────────────────────────────────────────
    const handleSearch = () => {
        if (tabNo === '1') loadFleets(); else loadRiders();
    };

    // ── Open fleet migrate modal ───────────────────────────────
    const openFleetMigrate = (fleet: any) => {
        setMigrateFleetUser(fleet);
        setAutoMigrateRiders(false);
        setFleetRiderRates({ metro_rate: '', other_rate: '' });
        setMigrateFleetModal(true);
    };

    // ── Handle fleet migrate ───────────────────────────────────
    const handleFleetMigrate = () => {
        if (!migrateFleetUser?.id) return;

        if (autoMigrateRiders) {
            if (!fleetRiderRates.metro_rate || !fleetRiderRates.other_rate) {
                toast.warn('Please set both rates for the riders.');
                return;
            }
        }

        setActionLoader(true);

        const payload: any = {};
        if (autoMigrateRiders) {
            payload.auto_migrate_riders = true;
            payload.rider_metro_rate = fleetRiderRates.metro_rate;
            payload.rider_other_rate = fleetRiderRates.other_rate;
        }

        SuperAdminApis.migrateFleet(migrateFleetUser.id, payload)
            .then((res: AxiosResponse<any>) => {
                setActionLoader(false);
                setMigrateFleetModal(false);
                if (res?.data?.status) {
                    toast.success(res.data.message);
                    loadStats();
                    loadFleets();
                } else {
                    toast.error(res?.data?.message || 'Migration failed.');
                }
            })
            .catch((err: any) => {
                setActionLoader(false);
                toast.error(err?.response?.data?.message || 'Migration failed.');
            });
    };

    // ── Open rider migrate modal ───────────────────────────────
    const openRiderMigrate = (rider: any) => {
        setMigrateRiderUser(rider);
        setRiderData({ metro_rate: '', other_rate: '', rider_town: '', branch: rider.office || '' });
        setMigrateRiderModal(true);
    };

    // ── Handle rider migrate ───────────────────────────────────
    const handleRiderMigrate = () => {
        if (!riderData.metro_rate || !riderData.other_rate) {
            toast.warn('Please set both rates.');
            return;
        }
        if (!migrateRiderUser?.id) return;

        setActionLoader(true);

        SuperAdminApis.migrateRider(migrateRiderUser.id, riderData)
            .then((res: AxiosResponse<any>) => {
                setActionLoader(false);
                setMigrateRiderModal(false);
                if (res?.data?.status) {
                    toast.success(res.data.message);
                    loadStats();
                    loadRiders();
                } else {
                    toast.error(res?.data?.message || 'Migration failed.');
                }
            })
            .catch((err: any) => {
                setActionLoader(false);
                toast.error(err?.response?.data?.message || 'Migration failed.');
            });
    };

    // ── Bulk migrate ───────────────────────────────────────────
    const toggleSelect = (id: number) => {
        setSelectedIds(prev => prev.includes(id) ? prev.filter(i => i !== id) : [...prev, id]);
    };

    const handleBulkMigrate = () => {
        if (!bulkData.metro_rate || !bulkData.other_rate) { toast.warn('Please set both rates.'); return; }
        if (selectedIds.length === 0) { toast.warn('No users selected.'); return; }
        setActionLoader(true);

        SuperAdminApis.bulkMigrateLegacy({ user_ids: selectedIds, ...bulkData }).then((res: AxiosResponse<any>) => {
            setActionLoader(false);
            setBulkModal(false);
            if (res?.data?.status) {
                toast.success(res.data.message);
                setSelectedIds([]);
                loadStats();
                if (tabNo === '1') loadFleets(); else loadRiders();
            }
        }).catch(() => { setActionLoader(false); toast.error('Bulk migration failed.'); });
    };

    const paginate = (data: any, label: string) => {
        const page = label === 'Next &raquo;' || label === '&laquo; Previous'
            ? data?.links?.find((l: any) => l.label === label)?.url?.split('page=')[1] : label;
        if (page) { if (tabNo === '1') loadFleets(page); else loadRiders(page); }
    };

    const getFleetName = (id: any) => {
        if (!id) return "Independent";
        const found = Array.isArray(fleetList) ? fleetList.find((f: any) => f.id == id) : null;
        return found ? (found.first_name || found.name || `Fleet #${id}`) : `Fleet #${id}`;
    };

    return (
        <>
            <AdminSidebar title="Legacy Migration" />
            <div className="relative md:ml-64 bg-[#FAFAFA]">
                <AdminNavbar title="Legacy Migration" />

                <div className="lg:px-10 pb-6 px-6 bg-[#FAFAFA] min-h-screen">
                    <h3 className="text-[15px] text-[#1C1C1C] font-semibold mt-5 mb-2">Legacy User Migration</h3>
                    <p className="text-xs text-gray-500 mb-4">Migrate existing fleet operators and riders to the new system with wallet and two-tier pricing.</p>

                    {/* ── Stats Cards ───────────────────────────────── */}
                    {stats && (
                        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-5">
                            <div className="bg-white rounded-lg p-4 shadow-sm">
                                <p className="text-xs text-gray-500">Unmigrated Fleets</p>
                                <p className="text-xl font-bold text-orange-600">{stats.unmigrated_fleets}</p>
                            </div>
                            <div className="bg-white rounded-lg p-4 shadow-sm">
                                <p className="text-xs text-gray-500">Unmigrated Riders</p>
                                <p className="text-xl font-bold text-orange-600">{stats.unmigrated_riders}</p>
                            </div>
                            <div className="bg-white rounded-lg p-4 shadow-sm">
                                <p className="text-xs text-gray-500">Migrated Fleets</p>
                                <p className="text-xl font-bold text-green-600">{stats.migrated_fleets}</p>
                            </div>
                            <div className="bg-white rounded-lg p-4 shadow-sm">
                                <p className="text-xs text-gray-500">Migrated Riders</p>
                                <p className="text-xl font-bold text-green-600">{stats.migrated_riders}</p>
                            </div>
                        </div>
                    )}

                    {stats?.migration_complete && (
                        <div className="bg-green-50 border border-green-200 rounded-lg p-4 mb-5 text-center">
                            <p className="text-green-700 font-semibold">All legacy users have been migrated!</p>
                        </div>
                    )}

                    {/* ── Tabs ──────────────────────────────────────── */}
                    <div className="flex gap-4 mb-4">
                        <button onClick={() => setTabNo('1')} className={`px-4 py-2 text-sm font-semibold rounded-md ${tabNo === '1' ? 'bg-[#E04343] text-white' : 'bg-gray-200 text-gray-600'}`}>
                            Existing Fleets ({stats?.unmigrated_fleets || 0})
                        </button>
                        <button onClick={() => setTabNo('2')} className={`px-4 py-2 text-sm font-semibold rounded-md ${tabNo === '2' ? 'bg-[#E04343] text-white' : 'bg-gray-200 text-gray-600'}`}>
                            Existing Riders ({stats?.unmigrated_riders || 0})
                        </button>
                    </div>

                    {/* ── Search & Bulk ─────────────────────────────── */}
                    <div className="flex gap-2 mb-3 flex-wrap">
                        <input
                            type="text"
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                            onKeyDown={(e) => { if (e.key === 'Enter') handleSearch(); }}
                            placeholder="Search by name, email, phone..."
                            className="flex-1 min-w-[200px] border border-gray-300 rounded-md p-2 text-sm"
                        />
                        {tabNo === '2' && (
                            <select
                                value={fleetFilter}
                                onChange={(e) => setFleetFilter(e.target.value)}
                                className="min-w-[150px] border border-gray-300 rounded-md p-2 text-sm text-gray-600"
                            >
                                <option value="">All Fleets</option>
                                {Array.isArray(fleetList) && fleetList.map((f: any) => (
                                    <option key={f.id} value={f.id}>{f.first_name || f.name}</option>
                                ))}
                            </select>
                        )}
                        <button onClick={handleSearch} className="bg-[#E04343] text-white px-4 py-2 rounded-md text-sm font-semibold">Search</button>
                        {selectedIds.length > 0 && tabNo === '2' && (
                            <button onClick={() => { setBulkData({ metro_rate: '', other_rate: '', rider_town: '', branch: '' }); setBulkModal(true); }} className="bg-green-600 text-white px-4 py-2 rounded-md text-sm font-semibold">
                                Migrate Selected ({selectedIds.length})
                            </button>
                        )}
                    </div>

                    {/* ── Fleets Tab ────────────────────────────────── */}
                    {tabNo === '1' && (
                        <div className="relative overflow-x-auto">
                            <table className="w-full text-sm text-left text-gray-500 border-separate border-spacing-y-2">
                                <thead className="text-[11px] text-[#030229] bg-[#FAFAFA] uppercase">
                                    <tr>
                                        <th className="px-2 py-2">Name</th>
                                        <th className="px-2 py-2">Email</th>
                                        <th className="px-2 py-2">Phone</th>
                                        <th className="px-2 py-2">Riders</th>
                                        <th className="px-2 py-2">Activated</th>
                                        <th className="px-2 py-2">Created</th>
                                        <th className="px-4 py-2">Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {loader ? (
                                        <tr><td colSpan={7} className="text-center py-10">
                                            <Oval visible={true} height="40" width="40" color="#E04343" secondaryColor="#FCBF94" ariaLabel="oval-loading" wrapperClass="flex justify-center" />
                                        </td></tr>
                                    ) : fleets?.data?.length > 0 ? fleets.data.map((f: any) => (
                                        <tr key={f.id} className="bg-white">
                                            <td className="px-2 py-3 text-xs font-semibold">{f.first_name} {f.last_name}</td>
                                            <td className="px-2 py-3 text-xs">{f.email}</td>
                                            <td className="px-2 py-3 text-xs">{f.phone_number}</td>
                                            <td className="px-2 py-3 text-xs font-semibold">{f.rider_count} riders</td>
                                            <td className="px-2 py-3">
                                                <span className={`text-[10px] px-1.5 py-0.5 rounded font-bold ${f.isVerified === 'true' ? 'bg-green-100 text-green-700' : 'bg-yellow-100 text-yellow-700'}`}>
                                                    {f.isVerified}
                                                </span>
                                            </td>
                                            <td className="px-2 py-3 text-xs">{new Date(f.created_at).toLocaleDateString()}</td>
                                            <td className="px-4 py-3">
                                                <button onClick={() => openFleetMigrate(f)} className="bg-green-600 text-white px-3 py-1 rounded text-xs font-semibold">Migrate</button>
                                            </td>
                                        </tr>
                                    )) : (
                                        <tr><td colSpan={7} className="text-center py-8 text-gray-400">No unmigrated fleets found.</td></tr>
                                    )}
                                </tbody>
                            </table>
                            <div className="flex justify-end mt-4">
                                {fleets?.links?.map((link: any, idx: number) => (
                                    <button key={idx} onClick={() => paginate(fleets, link.label)} disabled={link.active || !link.url}
                                        className={`mx-0.5 py-1 px-2 text-xs ${link.active ? 'bg-[#E04343] text-white' : link.url ? 'bg-gray-200 text-black' : 'bg-gray-100 text-gray-400'}`}>
                                        {link.label.replace('&laquo; Previous', '< Prev').replace('Next &raquo;', 'Next >')}
                                    </button>
                                ))}
                            </div>
                        </div>
                    )}

                    {/* ── Riders Tab ────────────────────────────────── */}
                    {tabNo === '2' && (
                        <div className="relative overflow-x-auto">
                            <table className="w-full text-sm text-left text-gray-500 border-separate border-spacing-y-2">
                                <thead className="text-[11px] text-[#030229] bg-[#FAFAFA] uppercase">
                                    <tr>
                                        <th className="px-2 py-2"><input type="checkbox" onChange={() => {
                                            if (selectedIds.length === (riders?.data?.length || 0)) setSelectedIds([]);
                                            else setSelectedIds(riders?.data?.map((r: any) => r.id) || []);
                                        }} checked={selectedIds.length > 0 && selectedIds.length === (riders?.data?.length || 0)} /></th>
                                        <th className="px-2 py-2">Name</th>
                                        <th className="px-2 py-2">Email</th>
                                        <th className="px-2 py-2">Phone</th>
                                        <th className="px-2 py-2">Fleet</th>
                                        <th className="px-2 py-2">Fleet Migrated?</th>
                                        <th className="px-2 py-2">Branch</th>
                                        <th className="px-4 py-2">Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {loader ? (
                                        <tr><td colSpan={8} className="text-center py-10">
                                            <Oval visible={true} height="40" width="40" color="#E04343" secondaryColor="#FCBF94" ariaLabel="oval-loading" wrapperClass="flex justify-center" />
                                        </td></tr>
                                    ) : riders?.data?.length > 0 ? riders.data.map((r: any) => (
                                        <tr key={r.id} className="bg-white">
                                            <td className="px-2 py-3"><input type="checkbox" checked={selectedIds.includes(r.id)} onChange={() => toggleSelect(r.id)} /></td>
                                            <td className="px-2 py-3 text-xs font-semibold">{r.first_name} {r.last_name}</td>
                                            <td className="px-2 py-3 text-xs">{r.email}</td>
                                            <td className="px-2 py-3 text-xs">{r.phone_number}</td>
                                            <td className="px-2 py-3 text-xs">{r.fleet_id ? getFleetName(r.fleet_id) : <span className="text-gray-300">Independent</span>}</td>
                                            <td className="px-2 py-3">
                                                {r.fleet_id ? (
                                                    <span className={`text-[10px] px-1.5 py-0.5 rounded font-bold ${r.fleet_migrated ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-600'}`}>
                                                        {r.fleet_migrated ? 'Yes' : 'No — migrate fleet first'}
                                                    </span>
                                                ) : <span className="text-[10px] text-gray-400">N/A</span>}
                                            </td>
                                            <td className="px-2 py-3 text-xs">{r.office || '—'}</td>
                                            <td className="px-4 py-3">
                                                <button
                                                    onClick={() => openRiderMigrate(r)}
                                                    disabled={r.fleet_id && !r.fleet_migrated}
                                                    className={`px-3 py-1 rounded text-xs font-semibold ${(!r.fleet_id || r.fleet_migrated)
                                                        ? 'bg-green-600 text-white hover:bg-green-700'
                                                        : 'bg-gray-300 text-gray-500 cursor-not-allowed'
                                                        }`}
                                                >
                                                    Migrate
                                                </button>
                                            </td>
                                        </tr>
                                    )) : (
                                        <tr><td colSpan={8} className="text-center py-8 text-gray-400">No unmigrated riders found.</td></tr>
                                    )}
                                </tbody>
                            </table>
                            <div className="flex justify-end mt-4">
                                {riders?.links?.map((link: any, idx: number) => (
                                    <button key={idx} onClick={() => paginate(riders, link.label)} disabled={link.active || !link.url}
                                        className={`mx-0.5 py-1 px-2 text-xs ${link.active ? 'bg-[#E04343] text-white' : link.url ? 'bg-gray-200 text-black' : 'bg-gray-100 text-gray-400'}`}>
                                        {link.label.replace('&laquo; Previous', '< Prev').replace('Next &raquo;', 'Next >')}
                                    </button>
                                ))}
                            </div>
                        </div>
                    )}
                </div>
            </div>

            {/* ═══════════════════════════════════════════════════════
          FLEET MIGRATE MODAL — No rates/town/branch for fleet itself
          Toggle to auto-migrate riders under fleet with same rates
          ═══════════════════════════════════════════════════════ */}
            <Modal visible={migrateFleetModal} width="450" height={autoMigrateRiders ? "420" : "300"} effect="fadeInUp" onClickAway={() => setMigrateFleetModal(false)}>
                <div className="p-4" style={{ height: '100%', overflow: 'auto' }}>
                    <div className="flex justify-between mb-3">
                        <p className="font-bold">Migrate Fleet: {migrateFleetUser?.first_name}</p>
                        <p className="cursor-pointer" onClick={() => setMigrateFleetModal(false)}><SvgElement type={icontypesEnum.CANCEL} /></p>
                    </div>
                    <p className="text-xs text-gray-500 mb-2">{migrateFleetUser?.email} | {migrateFleetUser?.phone_number}</p>
                    {migrateFleetUser?.rider_count > 0 && (
                        <p className="text-xs text-blue-600 mb-4">This fleet has {migrateFleetUser.rider_count} rider(s) under it.</p>
                    )}

                    <div className="bg-purple-50 rounded-lg p-3 mb-4 text-[12px] text-purple-700">
                        Migrating this fleet will create a Fleet profile, activate their account, and create a wallet for them.
                    </div>

                    {/* Auto-migrate riders toggle */}
                    {migrateFleetUser?.rider_count > 0 && (
                        <>
                            <div className="flex items-center justify-between bg-gray-50 rounded-lg p-3 mb-4">
                                <div>
                                    <p className="text-[13px] font-semibold text-[#333333]">Auto-migrate riders</p>
                                    <p className="text-[11px] text-gray-500">
                                        {autoMigrateRiders
                                            ? `All ${migrateFleetUser.rider_count} rider(s) will be migrated with the same rates.`
                                            : 'Migrate fleet only. You can migrate riders individually later.'}
                                    </p>
                                </div>
                                <button
                                    type="button"
                                    onClick={() => setAutoMigrateRiders(!autoMigrateRiders)}
                                    className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${autoMigrateRiders ? 'bg-green-500' : 'bg-gray-300'}`}
                                >
                                    <span className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${autoMigrateRiders ? 'translate-x-6' : 'translate-x-1'}`} />
                                </button>
                            </div>

                            {autoMigrateRiders && (
                                <div className="grid grid-cols-2 gap-3 mb-4">
                                    <div>
                                        <label className="text-xs text-gray-600 mb-1 block">Metro Rate (₦) *</label>
                                        <input type="number" value={fleetRiderRates.metro_rate} onChange={(e) => setFleetRiderRates({ ...fleetRiderRates, metro_rate: e.target.value })} className="w-full border border-gray-300 rounded-md p-2 text-sm" placeholder="e.g., 500" />
                                        <p className="text-[10px] text-gray-400 mt-0.5">Same rate for all riders</p>
                                    </div>
                                    <div>
                                        <label className="text-xs text-gray-600 mb-1 block">Other Rate (₦) *</label>
                                        <input type="number" value={fleetRiderRates.other_rate} onChange={(e) => setFleetRiderRates({ ...fleetRiderRates, other_rate: e.target.value })} className="w-full border border-gray-300 rounded-md p-2 text-sm" placeholder="e.g., 800" />
                                    </div>
                                </div>
                            )}
                        </>
                    )}

                    <button onClick={handleFleetMigrate} disabled={actionLoader} className="bg-green-600 text-white py-2.5 rounded w-full text-sm font-semibold flex items-center justify-center gap-2">
                        {autoMigrateRiders ? `Migrate Fleet + ${migrateFleetUser?.rider_count} Rider(s)` : 'Migrate Fleet'}
                        <Oval visible={actionLoader} height="16" width="16" color="#fff" secondaryColor="#ccc" ariaLabel="loading" />
                    </button>
                </div>
            </Modal>

            {/* ═══════════════════════════════════════════════════════
          RIDER MIGRATE MODAL — Requires rates, optional town/branch
          ═══════════════════════════════════════════════════════ */}
            <Modal visible={migrateRiderModal} width="450" height="380" effect="fadeInUp" onClickAway={() => setMigrateRiderModal(false)}>
                <div className="p-4" style={{ height: '100%', overflow: 'auto' }}>
                    <div className="flex justify-between mb-3">
                        <p className="font-bold">Migrate Rider: {migrateRiderUser?.first_name}</p>
                        <p className="cursor-pointer" onClick={() => setMigrateRiderModal(false)}><SvgElement type={icontypesEnum.CANCEL} /></p>
                    </div>
                    <p className="text-xs text-gray-500 mb-2">{migrateRiderUser?.email} | {migrateRiderUser?.phone_number}</p>
                    {migrateRiderUser?.fleet_id && (
                        <p className="text-xs text-orange-600 mb-4">Under fleet: {getFleetName(migrateRiderUser.fleet_id)} — no wallet will be created. Earnings go to fleet wallet.</p>
                    )}
                    {!migrateRiderUser?.fleet_id && (
                        <p className="text-xs text-blue-600 mb-4">Independent rider — a wallet will be created.</p>
                    )}

                    <div className="grid grid-cols-2 gap-3 mb-3">
                        <div>
                            <label className="text-xs text-gray-600 mb-1 block">Metro Rate (₦) *</label>
                            <input type="number" value={riderData.metro_rate} onChange={(e) => setRiderData({ ...riderData, metro_rate: e.target.value })} className="w-full border border-gray-300 rounded-md p-2 text-sm" placeholder="e.g., 500" />
                        </div>
                        <div>
                            <label className="text-xs text-gray-600 mb-1 block">Other Rate (₦) *</label>
                            <input type="number" value={riderData.other_rate} onChange={(e) => setRiderData({ ...riderData, other_rate: e.target.value })} className="w-full border border-gray-300 rounded-md p-2 text-sm" placeholder="e.g., 800" />
                        </div>
                    </div>
                    <div className="mb-3">
                        <label className="text-xs text-gray-600 mb-1 block">Town / City</label>
                        <input type="text" value={riderData.rider_town} onChange={(e) => setRiderData({ ...riderData, rider_town: e.target.value })} className="w-full border border-gray-300 rounded-md p-2 text-sm" placeholder="e.g., Lagos" />
                    </div>
                    <div className="mb-4">
                        <label className="text-xs text-gray-600 mb-1 block">Branch</label>
                        <input type="text" value={riderData.branch} onChange={(e) => setRiderData({ ...riderData, branch: e.target.value })} className="w-full border border-gray-300 rounded-md p-2 text-sm" />
                    </div>

                    <button onClick={handleRiderMigrate} disabled={actionLoader} className="bg-green-600 text-white py-2.5 rounded w-full text-sm font-semibold flex items-center justify-center gap-2">
                        Migrate & Approve
                        <Oval visible={actionLoader} height="16" width="16" color="#fff" secondaryColor="#ccc" ariaLabel="loading" />
                    </button>
                </div>
            </Modal>

            {/* ── Bulk Migrate Modal (riders only) ──────────────── */}
            <Modal visible={bulkModal} width="450" height="350" effect="fadeInUp" onClickAway={() => setBulkModal(false)}>
                <div className="p-4" style={{ height: '100%', overflow: 'auto' }}>
                    <div className="flex justify-between mb-3">
                        <p className="font-bold">Bulk Migrate ({selectedIds.length} riders)</p>
                        <p className="cursor-pointer" onClick={() => setBulkModal(false)}><SvgElement type={icontypesEnum.CANCEL} /></p>
                    </div>
                    <p className="text-xs text-gray-500 mb-4">All selected riders will be migrated with the same rates.</p>

                    <div className="grid grid-cols-2 gap-3 mb-3">
                        <div>
                            <label className="text-xs text-gray-600 mb-1 block">Metro Rate (₦) *</label>
                            <input type="number" value={bulkData.metro_rate} onChange={(e) => setBulkData({ ...bulkData, metro_rate: e.target.value })} className="w-full border border-gray-300 rounded-md p-2 text-sm" />
                        </div>
                        <div>
                            <label className="text-xs text-gray-600 mb-1 block">Other Rate (₦) *</label>
                            <input type="number" value={bulkData.other_rate} onChange={(e) => setBulkData({ ...bulkData, other_rate: e.target.value })} className="w-full border border-gray-300 rounded-md p-2 text-sm" />
                        </div>
                    </div>
                    <div className="mb-3">
                        <label className="text-xs text-gray-600 mb-1 block">Town / City</label>
                        <input type="text" value={bulkData.rider_town} onChange={(e) => setBulkData({ ...bulkData, rider_town: e.target.value })} className="w-full border border-gray-300 rounded-md p-2 text-sm" />
                    </div>
                    <div className="mb-4">
                        <label className="text-xs text-gray-600 mb-1 block">Branch</label>
                        <input type="text" value={bulkData.branch} onChange={(e) => setBulkData({ ...bulkData, branch: e.target.value })} className="w-full border border-gray-300 rounded-md p-2 text-sm" />
                    </div>

                    <button onClick={handleBulkMigrate} disabled={actionLoader} className="bg-green-600 text-white py-2.5 rounded w-full text-sm font-semibold flex items-center justify-center gap-2">
                        Migrate All ({selectedIds.length})
                        <Oval visible={actionLoader} height="16" width="16" color="#fff" secondaryColor="#ccc" ariaLabel="loading" />
                    </button>
                </div>
            </Modal>

            <ToastContainer position="top-right" autoClose={2000} hideProgressBar />
        </>
    );
}

export default LegacyMigration;